module.exports = __webpack_public_path__ + "img/talent-management.070eacc9.png";